<template>
  <div :class="isNumber(discountPrice) && 'line-through text-xs text-gray-400'">
    kr. {{ formatPrice(recurringPrice) }} per mnd
  </div>
  <div v-if="isNumber(discountPrice)">
    kr. {{ formatPrice(discountPrice) }} per mnd
  </div>
</template>

<script lang="ts" setup>
import { formatPrice } from "../../helpers/priceHelpers";
import { useVpsAddOnCatalogStore } from "../../stores/catalog/vps-addon-catalog";
import { isNumber } from "~/helpers/objectHelpers";

const props = defineProps<{
  addOnId: number;
}>();

const addonCatalog = useVpsAddOnCatalogStore();

const subscription = computed(() =>
  addonCatalog.getSubscriptionByAddOnId(props.addOnId)
);

const recurringPrice = computed(() => {
  return subscription.value?.priceRecurring?.unitPriceWithDiscount ?? "?";
});

const discountPrice = computed(() => {
  if (!isNumber(recurringPrice.value)) {
    return null;
  }

  const startupPrice = subscription.value?.priceStartup?.unitPriceWithDiscount;

  if (!isNumber(startupPrice)) {
    return null;
  }

  if (startupPrice >= recurringPrice.value) {
    return null;
  }

  return subscription.value?.priceStartup?.unitPriceWithDiscount;
});
</script>

<style></style>
